import SoilTypesDataService from "../../service/SoilTypesDataService";

const newSoilType = {
    name: '',
    kp: null,
    Erw: null,
    Erj0: null,
    sp: null,
    fc: null,
    wp: null,
    ssp: null
}

const initialState = {
    soilTypes: [],
    activeSoilType: null,
    newSoilType: {...newSoilType},
}

export default {
    namespaced: true,
    state: {...initialState},
    actions: {
        async fetchSoilTypesList({commit}) {
            try {
                const resp = await SoilTypesDataService.getAll()

                if (resp.status === 200) {
                    commit('setSoilTypes', resp.data)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async fetchSoilType({commit}, id) {
            try {
                const resp = await SoilTypesDataService.get(id)

                if (resp.status === 200) {
                    commit('setSoilType', resp.data)
                }

            } catch (e) {
                console.log(e)
            }
        },
        async updateSoilType({state, dispatch}) {
            try {
                const resp = await SoilTypesDataService.update(state.activeSoilType)

                if (resp.status === 200) {
                    dispatch('app/showSnackbar', {
                        bool: true,
                        message: 'Sensor data updated!',
                        type: 'success'
                    }, {root: true})
                    dispatch("fetchSoilTypesList")
                }
            } catch (e) {
                console.log(e)
            }
        },
        async createSoilType({state, commit, dispatch}) {
            try {
                commit('setLoading', true)
                const resp = await SoilTypesDataService.createSoilType(state.newSoilType)
                if (resp.status === 201) {
                    commit('resetNewSoilType')
                    dispatch('app/showSnackbar', {
                        bool: true,
                        message: resp.data.message,
                        type: 'success'
                    }, {root: true})
                    dispatch('fetchSoilTypesList')
                } else {
                    dispatch('app/showSnackbar', {
                        bool: true,
                        message: resp.message,
                        type: 'error'
                    }, {root: true})
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        }
    },
    mutations: {
        setSoilTypes(state, data) {
            state.soilTypes = data
        },
        setSoilType(state, data) {
            state.activeSoilType = data
        },
        setLoading(state, bool) {
            state.loading = bool
        },
        resetNewSoilType(state) {
            state.newLocation = {...newSoilType}
        },
    }
}